import { useTranslation } from "next-i18next";
import React from "react";

import ActionButton from "@/components/buttons/action-button";
import { KINDS, SIZES } from "@/components/buttons/buttons.constants";

import styles from "./storeDirectory.module.scss";

type Props = {
    onClick: (event?: MouseEvent) => void;
};
const StoreDirectoryNoResults: React.FC<Props> = ({ onClick }) => {
    const { t } = useTranslation();

    const emptyResultsText = t("store.filters.notFound.noResults");
    const clearFiltersButtonLabel = t("store.filters.notFound.filterButtonText");
    return (
        <div className={styles.emptyResultsContainer}>
            <div className={styles.emptyResultsText}>
                <p>{emptyResultsText}</p>
            </div>
            <ActionButton
                disabled={false}
                fluid={false}
                kind={KINDS.PRIMARY}
                label={clearFiltersButtonLabel}
                size={SIZES.LARGE}
                onClick={onClick}
            />
        </div>
    );
};

export default StoreDirectoryNoResults;
